import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import { MapPin, Phone, Clock, Mail, ChevronRight, MessageCircle } from 'lucide-react';

const LOCATIONS = [
  {
    city: 'Milano',
    subtitle: 'Sede di Milano',
    address: 'Via Santa Sofia 10, 20122 Milano',
    phone: '+39 02 9876543',
    whatsapp: '+39 02 9876543',
    email: 'milano@primevision.it',
    hours: 'Lun-Ven: 9:00-18:00 | Sab: 9:00-13:00',
    mapLink: 'https://maps.google.com/?q=Via+Santa+Sofia+10+Milano',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.2!2d9.196!3d45.458!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDXCsDI3JzI5LjAiTiA5wrAxMSc0NS42IkU!5e0!3m2!1sit!2sit'
  },
  {
    city: 'Napoli',
    subtitle: 'c/o Clinica Posillipo',
    address: 'Via Posillipo 168, 80123 Napoli',
    phone: '+39 081 1234567',
    whatsapp: '+39 081 1234567',
    email: 'napoli@primevision.it',
    hours: 'Lun-Ven: 9:00-18:00 | Sab: 9:00-13:00',
    mapLink: 'https://maps.google.com/?q=Via+Posillipo+168+Napoli',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.8!2d14.194!3d40.819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQ5JzA4LjQiTiAxNMKwMTEnMzguNCJF!5e0!3m2!1sit!2sit'
  }
];

const Contatti = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 px-4" style={{ background: 'linear-gradient(160deg, #eaf5fc 0%, #f7fbfe 50%, #e1eef8 100%)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h1 
            className="text-4xl sm:text-5xl lg:text-6xl font-normal mb-6 tracking-tight"
            style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#2c4667' }}
            data-testid="contatti-hero-title"
          >
            Contatti
          </h1>
          <p className="text-lg md:text-xl leading-relaxed max-w-2xl mx-auto" style={{ color: '#2c4667' }}>
            Siamo qui per te. Contattaci per informazioni, prenotazioni o per qualsiasi domanda. 
            Il nostro team ti risponderà il prima possibile.
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="text-center p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-testid="contact-phone-card">
              <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center" style={{ background: '#2A9FCB' }}>
                <Phone className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#2c4667' }}>Telefono</h3>
              <p className="text-base" style={{ color: '#2c4667' }}>Milano: +39 02 9876543</p>
              <p className="text-base" style={{ color: '#2c4667' }}>Napoli: +39 081 1234567</p>
            </div>

            <div className="text-center p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-testid="contact-email-card">
              <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center" style={{ background: '#2A9FCB' }}>
                <Mail className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#2c4667' }}>Email</h3>
              <p className="text-base" style={{ color: '#2c4667' }}>info@primevision.it</p>
              <p className="text-base" style={{ color: '#2c4667' }}>prenotazioni@primevision.it</p>
            </div>

            <div className="text-center p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-testid="contact-whatsapp-card">
              <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center" style={{ background: '#25D366' }}>
                <MessageCircle className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#2c4667' }}>WhatsApp</h3>
              <p className="text-base" style={{ color: '#2c4667' }}>Scrivici per info rapide</p>
              <a 
                href="https://api.whatsapp.com/send/?phone=39021234567" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block mt-2 text-base font-medium hover:underline"
                style={{ color: '#25D366' }}
              >
                Apri WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Locations */}
      <section className="py-16 px-4" style={{ background: 'linear-gradient(160deg, #eaf5fc 0%, #f7fbfe 50%, #e1eef8 100%)' }}>
        <div className="max-w-6xl mx-auto">
          <h2 
            className="text-3xl sm:text-4xl font-normal mb-12 text-center tracking-tight"
            style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#2c4667' }}
            data-testid="locations-title"
          >
            Le Nostre Sedi
          </h2>

          <div className="grid md:grid-cols-2 gap-10">
            {LOCATIONS.map((loc, idx) => (
              <div 
                key={idx} 
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
                data-testid={`location-card-${loc.city.toLowerCase()}`}
              >
                {/* Map Placeholder */}
                <div className="h-56 flex items-center justify-center relative" style={{ background: 'linear-gradient(135deg, #2A9FCB 0%, #2c4667 100%)' }}>
                  <div className="text-center text-white">
                    <MapPin className="w-12 h-12 mx-auto mb-3 opacity-80" />
                    <p className="text-2xl font-semibold">{loc.city}</p>
                    {loc.subtitle && (
                      <p className="text-sm opacity-80 mt-1">{loc.subtitle}</p>
                    )}
                  </div>
                </div>

                {/* Info */}
                <div className="p-8">
                  <div className="space-y-4 mb-6">
                    <div className="flex items-start gap-3">
                      <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#2a9fcb' }} />
                      <p className="text-base" style={{ color: '#2c4667' }}>{loc.address}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <Phone className="w-5 h-5 flex-shrink-0" style={{ color: '#2a9fcb' }} />
                      <a href={`tel:${loc.phone.replace(/\s/g, '')}`} className="text-base hover:underline" style={{ color: '#2c4667' }}>{loc.phone}</a>
                    </div>
                    <div className="flex items-center gap-3">
                      <Mail className="w-5 h-5 flex-shrink-0" style={{ color: '#2a9fcb' }} />
                      <a href={`mailto:${loc.email}`} className="text-base hover:underline" style={{ color: '#2c4667' }}>{loc.email}</a>
                    </div>
                    <div className="flex items-start gap-3">
                      <Clock className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#2a9fcb' }} />
                      <p className="text-base" style={{ color: '#2c4667' }}>{loc.hours}</p>
                    </div>
                  </div>

                  <a 
                    href={loc.mapLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-white font-medium transition-all hover:opacity-90 shadow-md hover:shadow-lg"
                    style={{ background: '#FA7314' }}
                    data-testid={`directions-btn-${loc.city.toLowerCase()}`}
                  >
                    <MapPin className="w-4 h-4" />
                    Indicazioni Google Maps
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4" style={{ background: '#2c4667' }}>
        <div className="max-w-3xl mx-auto text-center">
          <h2 
            className="text-3xl sm:text-4xl font-normal mb-6 text-white tracking-tight"
            style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
          >
            Hai bisogno di una visita?
          </h2>
          <p className="text-lg text-white/80 mb-8">
            Prenota una visita oculistica presso una delle nostre sedi. Il nostro team di specialisti è a tua disposizione.
          </p>
          <Link 
            to="/prenota"
            className="inline-flex items-center gap-2 px-10 py-4 rounded-xl text-white text-lg font-medium transition-all hover:opacity-90 shadow-xl hover:shadow-2xl hover:-translate-y-1"
            style={{ background: '#FA7314' }}
            data-testid="contatti-prenota-cta"
          >
            Prenota una Visita
            <ChevronRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contatti;
